import omitBy from "lodash/omitBy";
import isNil from "lodash/isNil";
import isNaN from "lodash/isNaN";
import isEmpty from "lodash/isEmpty";

const formatImage = (value, name) => {
  if (!value || typeof value === "string") {
    return { [name]: value };
  }
  return value;
};

const getNonNullishValues = data => omitBy(data, isNil, isNaN);
const getNonEmptyValues = data => omitBy(data, isEmpty);

export { formatImage, getNonNullishValues, getNonEmptyValues };
